import {nuskin} from '@nuskin/ns-util';

nuskin.newShop = {};

export default nuskin.newShop;